import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  // If the user is not authenticated, redirect to the login page
  if (!user || !user.data?.token) {
    return <Navigate to="/" replace />;
  }

  // If the user is authenticated, render the children
  return children;
};

export default ProtectedRoute;